<template>
  <div v-if="visible" class="terms-modal-overlay" @click.self="close">
    <div class="terms-modal">
      <button class="close-btn" @click="close">
        <i class="fa fa-times"></i>
      </button>
      
      <h3 class="title">{{ $t('terms.title_terms') }}</h3>
      
      <div class="terms-content-scroll">
        <div class="content-terms">
          <p class="text-sub text-effective">
            <strong>{{ $t('terms.new.effective_date') }}</strong> {{ $t('terms.new.effective_date_val') }}<br>
            <strong>{{ $t('terms.new.entity_label') }}</strong> {{ $t('terms.new.entity_val') }}
          </p>

          <div class="para-term">
            <div class="t-bold-term">{{ $t('terms.new.intro_title') }}</div>
            <p class="text-sub">{{ $t('terms.new.intro_p1') }}</p>
            <p class="text-sub">{{ $t('terms.new.intro_p2') }}</p>
            <p class="text-sub">{{ $t('terms.new.intro_p3') }}</p>
            <p class="text-sub">{{ $t('terms.new.intro_p4') }}</p>
          </div>

          <div class="para-term">
            <div class="t-bold-term">{{ $t('terms.new.eligibility_title') }}</div>
            <p class="text-sub">{{ $t('terms.new.eligibility_intro') }}</p>
            <ul>
              <li>{{ $t('terms.new.eligibility_li1') }}</li>
              <li>{{ $t('terms.new.eligibility_li2') }}</li>
              <li>{{ $t('terms.new.eligibility_li3') }}</li>
              <li>{{ $t('terms.new.eligibility_li4') }}</li>
            </ul>
            <p class="text-sub">{{ $t('terms.new.eligibility_outro') }}</p>
          </div>

          <div class="para-term">
            <div class="t-bold-term">{{ $t('terms.new.services_title') }}</div>
            
            <div class="m-bottom">
              <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_a_title') }}</div>
              <p class="text-sub">{{ $t('terms.new.service_a_desc') }}</p>
              <ul>
                <li>{{ $t('terms.new.service_a_li1') }}</li>
                <li>{{ $t('terms.new.service_a_li2') }}</li>
                <li>{{ $t('terms.new.service_a_li3') }}</li>
              </ul>
            </div>

            <div class="m-bottom">
              <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_b_title') }}</div>
              <p class="text-sub">{{ $t('terms.new.service_b_desc') }}</p>
              <ul>
                <li>{{ $t('terms.new.service_b_li1') }}</li>
                <li>{{ $t('terms.new.service_b_li2') }}</li>
                <li>{{ $t('terms.new.service_b_li3') }}</li>
              </ul>
            </div>

            <div>
              <div class="t-bold-term sub-term-title">{{ $t('terms.new.service_c_title') }}</div>
              <p class="text-sub">{{ $t('terms.new.service_c_desc') }}</p>
              <ul>
                <li>{{ $t('terms.new.service_c_li1') }}</li>
                <li>{{ $t('terms.new.service_c_li2') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="terms-footer">
        <div class="checkbox-container">
          <div class="checkbox-input">
            <input
              type="checkbox"
              id="checkboxTermsModal"
              v-model="checked"
            />
            <label for="checkboxTermsModal"></label>
          </div>
          <label class="checkbox-label" for="checkboxTermsModal">
            {{ $t('terms.agree') }} <router-link to="/terms" target="_blank" class="highlight">{{ $t('register.terms_2') }}</router-link>
          </label>
        </div>
        <button 
          class="btn-continue" 
          :disabled="!checked"
          @click="confirm"
        >
          {{ $t('terms.modal.continue') }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.checked = false;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      if (this.checked) {
        this.$emit('confirm');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.terms-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.terms-modal {
  background: #2c3038;
  padding: 30px;
  border-radius: 12px;
  width: 800px;
  max-width: 90%;
  max-height: 90vh;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  position: relative;
  display: flex;
  flex-direction: column;

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #8b92a7;
    font-size: 18px;
    cursor: pointer;
    padding: 5px;
    transition: color 0.2s;
    z-index: 1;

    &:hover {
      color: #fff;
    }
  }

  .title {
    text-align: center;
    margin-bottom: 20px;
    font-family: $font-inter-bold;
    color: #ffffff;
    font-size: 24px;
    flex-shrink: 0;
  }

  .terms-content-scroll {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 20px;
    padding-right: 10px; // Space for scrollbar
    
    // Custom scrollbar styling
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #1e2128;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #555;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #777;
    }
  }
}

.content-terms {
  color: #8b92a7;
  font-size: 14px;
  line-height: 1.6;

  .t-bold-term {
    color: #fff;
    font-family: $font-inter-bold;
    margin-bottom: 10px;
    margin-top: 20px;
    font-size: 16px;

    &.sub-term-title {
      font-size: 15px;
      color: #d1d5db;
      margin-top: 15px;
    }
  }

  .text-sub {
    margin-bottom: 10px;
    text-align: justify;
    
    &.text-effective {
      color: #fff;
      margin-bottom: 20px;
    }
  }

  ul {
    padding-left: 20px;
    margin-bottom: 10px;
    list-style: disc;
    
    li {
      margin-bottom: 5px;
    }
  }
  
  .m-bottom {
    margin-bottom: 15px;
  }
}

.terms-footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-top: 1px solid #3a3f4a;
  padding-top: 20px;

  .checkbox-container {
    display: flex;
    align-items: center;
    gap: 10px;
    
    .checkbox-label {
      color: #8b92a7;
      font-size: 14px;
      cursor: pointer;
      
      .highlight {
        color: #fff;
        text-decoration: underline;
      }
    }
  }

  .btn-continue {
    width: 100%;
    background: #00d09c;
    color: #ffffff;
    padding: 12px;
    border-radius: 4px;
    border: none;
    font-family: $font-inter-bold;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #00ba89;
    }

    &:disabled {
      background: #3a3f4a;
      color: #8b92a7;
      cursor: not-allowed;
    }
  }
}

// Reuse checkbox styles from global or Register if possible, or define here
// This mimics the checkbox style seen in Register.vue
.checkbox-input {
  position: relative;
  width: 20px;
  height: 20px;
  
  input {
    display: none;
    
    &:checked + label:after {
      content: "";
      position: absolute;
      top: 2px;
      left: 6px;
      width: 6px;
      height: 12px;
      border: solid #00d09c;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
    
    &:checked + label {
       border-color: #00d09c;
    }
  }
  
  label {
    position: absolute;
    width: 20px;
    height: 20px;
    border: 2px solid #8b92a7;
    border-radius: 4px;
    cursor: pointer;
    background: transparent;
    transition: all 0.2s;
  }
}
</style>
